import React, { useContext, useState, useEffect } from 'react';

import { Button } from 'semantic-ui-react';

import { useDispatch } from 'react-redux';

import { flagBusinessSaved } from 'actions/business';
import { PageContentContext } from 'components/modules/content/context';
import { PageComponentType } from 'components/modules/pages/types';
import WebsiteComponentInteractionContainer from 'components/modules/website-component-interaction/components/WebsiteComponentInteractionContainer';
import API from 'libs/api';
import ErrorHandler from 'libs/errors/errors';
import { objectToCamelCase, objectToSnakeCase } from 'libs/format';

import './CustomCtasConfiguration.scss';

const propTypes = {
  component: PageComponentType.isRequired,
};

export default function CustomCtasConfiguration({ component }) {
  const dispatch = useDispatch();

  const { refreshPages } = useContext(PageContentContext);
  const { interactions = [], id: componentConfigurationId } = component;

  const [localInteractions, setLocalInteractions] = useState(interactions);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLocalInteractions(interactions);
  }, [interactions]);

  const hasChanges = JSON.stringify(localInteractions) !== JSON.stringify(interactions);

  function onUpdateInteractions(updatedInteractions) {
    const interactionsInCamelCase = objectToCamelCase(updatedInteractions);
    setLocalInteractions(interactionsInCamelCase);
  }

  async function onSave() {
    try {
      setLoading(true);
      await API.updateComponentConfigurationWithData(componentConfigurationId, component, {
        ...component,
        interactions: localInteractions,
      });
      await refreshPages();
      dispatch(flagBusinessSaved(true));
    } catch (error) {
      ErrorHandler.capture(error);
    } finally {
      setLoading(false);
    }
  }

  function onCancel() {
    setLocalInteractions(interactions);
  }

  return (
    <div className="custom-ctas-configuration">
      <WebsiteComponentInteractionContainer
        interactions={objectToSnakeCase(localInteractions)}
        onUpdate={onUpdateInteractions}
        maxAllowedInteractions={2}
      />

      {hasChanges && (
        <div className="actions">
          <Button
            className="action-button-gray"
            disabled={loading}
            content="CANCEL"
            onClick={onCancel}
          />
          <Button
            className="secondary-navy"
            disabled={loading}
            loading={loading}
            content="SAVE"
            icon="save"
            onClick={onSave}
          />
        </div>
      )}
    </div>
  );
}

CustomCtasConfiguration.propTypes = propTypes;
